import type { Drug } from "../types";

export const erythromycinDrug: Drug = {
  id: "erythromycin",
  name: "Erythromycin",
  drugClass: "macrolide",
  defaultFoodTiming: "Take just before or with food",
  swallowingNote: "Tablets should be swallowed whole",
  formulations: [
    {
      id: "eryth-250-tab",
      type: "tablet_ir",
      strength: 250,
      strengthUnit: "mg",
      prescribedItemId: "dab454fd-9930-4237-9a8b-b1a80737fff2",
    },
    {
      id: "eryth-250-gr-tab",
      type: "tablet_gr",
      strength: 250,
      strengthUnit: "mg",
      canCrush: false,
      prescribedItemId: "fd7aff32-5ddf-4802-8608-577ff1497057",
    },
    {
      id: "eryth-500-tab",
      type: "tablet_ir",
      strength: 500,
      strengthUnit: "mg",
      prescribedItemId: "2657e1eb-922a-4095-bdcf-d5ab73151078",
    },
    {
      id: "eryth-125-5ml",
      type: "oral_suspension",
      strength: 125,
      strengthUnit: "mg",
      volumePer: 5,
      volumeUnit: "mL",
      bottleSize: 100,
      bottleSizeUnit: "mL",
      sugarFreeAvailable: true,
      prescribedItemId: "8599d48a-250b-440e-85d3-9a8889bc6cdd",
    },
    {
      id: "eryth-250-5ml",
      type: "oral_suspension",
      strength: 250,
      strengthUnit: "mg",
      volumePer: 5,
      volumeUnit: "mL",
      bottleSize: 100,
      bottleSizeUnit: "mL",
      sugarFreeAvailable: true,
      prescribedItemId: "ec4eaf87-22c9-4e2c-83f2-6b759b95a6e5",
    },
    {
      id: "eryth-500-5ml",
      type: "oral_suspension",
      strength: 500,
      strengthUnit: "mg",
      volumePer: 5,
      volumeUnit: "mL",
      bottleSize: 100,
      bottleSizeUnit: "mL",
      sugarFreeAvailable: true,
      prescribedItemId: "13333998-7986-4e07-88ff-9a0299c1a12f",
    },
  ],
};
